<template>
  <a-form :form="form" @submit.prevent="submit">
    <a-form-item label="Current Password">
      <a-input
        size="large"
        type="password"
        v-decorator="['password', { rules: rules.password }]"
      />
    </a-form-item>

    <a-form-item label="New Password">
      <a-input
        size="large"
        type="password"
        v-decorator="['new_password', { rules: rules.new_password }]"
      />
    </a-form-item>

    <a-form-item label="Confirm Password">
      <a-input
        size="large"
        type="password"
        v-decorator="['confirm_password', { rules: rules.confirm_password }]"
      />
    </a-form-item>

    <slot name="footer">
      <a-button type="primary" html-type="submit" size="large" block class="mt-3">Change password</a-button>
    </slot>
  </a-form>
</template>

<script>
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      rules: {
        password: [
          { required: true, message: 'Password is required' },
        ],
        new_password: [
          { required: true, message: 'New password is required' },
          { min: 8, message: 'Password must be at least 8 characters' },
        ],
        confirm_password: [
          { required: true, message: 'Confirm password is required' },
          {
            // eslint-disable-next-line standard/no-callback-literal
            validator: (rule, value, callback) => value && value !== this.form.getFieldValue('new_password') ? callback('Confirm password does not match') : callback(),
            message: 'Confirm password does not match',
          },
        ],
      },
    }
  },
  methods: {
    submit() {
      this.form.validateFields(async (errors, form) => {
        if (errors) {
          return
        }

        try {
          // eslint-disable-next-line no-unused-vars
          const _response = await this.$store.dispatch('user/changePassword', form)

          this.$notification.success({
            message: 'Your password successfully changed',
            placement: 'bottomRight',
          })
          this.form.resetFields()
        } catch (err) {
          this.$notification.error({
            message: err?.response?.data?.message || err.message,
            placement: 'bottomRight',
          })
        }
      })
    },
  },
}
</script>

<style>

</style>
